import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';

/**
 * General API error handler.
 *
 * 401 handling is done by `unauthorizedInterceptor` (with token refresh),
 * so this interceptor only handles other error statuses if needed.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // The backend refuses everything but the password change while it is required: go to that page.
      if (err.status === 403 && err.error?.code === 'password_change_required' && !router.url.startsWith('/change-password')) {
        const user = auth.user();
        if (user) {
          auth.setUser({ ...user, password_change_required: true });
        }
        router.navigate(['/change-password']);
      }
      // 401 is handled by unauthorizedInterceptor — do NOT redirect here
      // Future: add toast notifications for 5xx errors, etc.
      return throwError(() => err);
    })
  );
};
